<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Dialog para duplicação de grupo -->
    <v-dialog v-model="duplicarGrupoDialog" persistent max-width="500">
      <v-card>
        <v-card-title> Gostaria de duplicar este grupo? </v-card-title>
        <v-card-text v-if="loadingDuplicar">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="grey darken-1" text @click="fecharDialogDuplicar"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            @click="confirmarDuplicarGrupo"
            :loading="loadingDuplicar"
            >Sim</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para cancelamento de operação -->
    <v-dialog v-model="atualizarGrupoStatusDialog" persistent max-width="500">
      <v-card>
        <v-card-title> Deseja alterar o status deste grupo? </v-card-title>
        <v-card-text v-if="loadingCancelar">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="grey darken-1"
            text
            @click="fecharDialogAtualizarStatusGrupo"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            @click="atualizarStatusGrupoColaborador"
            :loading="loadingCancelar"
            >Sim</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para mensagens -->
    <v-dialog v-model="mensagemDialog" persistent max-width="400">
      <v-card>
        <v-card-title
          :class="mensagemTipo === 'sucesso' ? 'success--text' : 'error--text'"
        >
          {{ mensagemTipo === "sucesso" ? "Sucesso" : "Erro" }}
        </v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ mensagemTexto }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            :color="mensagemTipo === 'sucesso' ? 'success' : 'error'"
            text
            @click="mensagemDialog = false"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Compartilhamento -->
    <v-dialog v-model="dlgCompartilhar" max-width="1200">
      <v-card>
        <v-toolbar color="info" dark>
          <v-toolbar-title>Compartilhar grupo</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dlgCompartilhar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-2">
          <!-- Informações do grupo -->
          <v-card-title class="py-3 px-4 pt-2 pb-0">
            <div class="d-flex align-center">
              <v-avatar color="info" size="36" class="mr-3">
                <v-icon color="white" size="20" class="icon-avatar">
                  mdi-account-group
                </v-icon>
              </v-avatar>

              <div class="subtitle-1 font-weight-medium">
                {{ grupoSelecionado?.nome }}
              </div>
            </div>
          </v-card-title>
          <v-card-text class="py-2 px-4 mb-4">
            <div class="d-flex flex-wrap">
              <div class="d-flex align-center mr-6 mb-2" style="width: 45%">
                <v-icon size="18" color="primary" class="mr-2"
                  >mdi-account-tie</v-icon
                >
                <div>
                  <div class="caption grey--text text--darken-1">
                    Responsável
                  </div>
                  <div class="body-2">{{ grupoResponsavel }}</div>
                </div>
              </div>

              <div class="d-flex align-center mb-2" style="width: 45%">
                <v-icon size="18" color="grey darken-1" class="mr-2"
                  >mdi-calendar</v-icon
                >
                <div>
                  <div class="caption grey--text text--darken-1">Criado em</div>
                  <div class="body-2">{{ grupoSelecionado?.dataCriacao }}</div>
                </div>
              </div>

              <div class="d-flex align-center mr-6" style="width: 45%">
                <v-icon size="18" color="grey darken-1" class="mr-2"
                  >mdi-account-multiple</v-icon
                >
                <div>
                  <div class="caption grey--text text--darken-1">
                    Participantes
                  </div>
                  <div class="body-2">{{ totalParticipantes }}</div>
                </div>
              </div>

              <div class="d-flex align-center" style="width: 45%">
                <v-icon size="18" color="info" class="mr-2"
                  >mdi-share-variant</v-icon
                >
                <div>
                  <div class="caption grey--text text--darken-1">
                    Compartilhamentos
                  </div>
                  <div class="body-2">
                    {{ colaboradoresCompartilhados.length }}
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <!-- Tabela de colaboradores disponíveis -->
          <v-card outlined class="mb-4">
            <v-card-title class="subtitle-1 py-2">
              Adicionar colaboradores
            </v-card-title>

            <v-divider class="mb-2"></v-divider>
            <v-card-text class="py-0">
              <v-text-field
                v-model="searchDisponiveis"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                dense
                outlined
                clearable
                class="mb-2"
              ></v-text-field>
              <v-data-table
                :headers="headersDisponiveis"
                :items="colaboradoresDisponiveis"
                :search="searchDisponiveis"
                :loading="loadingCompartilhamento"
                :items-per-page="5"
                class="elevation-0"
              >
                <template v-slot:item.acoes="{ item }">
                  <v-btn
                    small
                    text
                    color="primary"
                    @click="adicionarCompartilhamento(item)"
                  >
                    <v-icon left small>mdi-plus</v-icon>
                    Selecionar
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <!-- Lista de colaboradores compartilhados -->
          <v-card outlined>
            <v-card-title class="subtitle-1 py-2">
              Compartilhado com
              <v-spacer></v-spacer>
              <div
                class="caption"
                v-if="colaboradoresCompartilhados.length > 0"
              >
                {{ colaboradoresCompartilhados.length }} colaborador(es)
              </div>
            </v-card-title>

            <v-divider class="mb-2"></v-divider>

            <v-card-text class="py-0">
              <v-text-field
                v-model="searchCompartilhados"
                append-icon="mdi-magnify"
                label="Buscar colaboradores"
                single-line
                hide-details
                dense
                outlined
                class="mb-2"
                clearable
                v-if="colaboradoresCompartilhados.length > 0"
              ></v-text-field>

              <div
                class="text-center grey--text py-4"
                v-if="colaboradoresCompartilhados.length === 0"
              >
                Nenhum colaborador selecionado
              </div>

              <v-data-table
                v-else
                :headers="[
                  { text: '', value: 'avatar', sortable: false, width: '40px' },
                  { text: '', value: 'nome' },
                  {
                    text: '',
                    value: 'gerenciar',
                    sortable: false,
                    align: 'center',
                    width: '100px',
                  },
                  {
                    text: '',
                    value: 'acoes',
                    sortable: false,
                    align: 'end',
                    width: '100px',
                  },
                ]"
                :items="colaboradoresCompartilhados"
                :search="searchCompartilhados"
                :loading="loadingCompartilhamento"
                :items-per-page="5"
                hide-default-header
                class="elevation-0 lista-sem-borda"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15],
                  'items-per-page-text': 'Por página:',
                  'show-first-last-page': true,
                  'first-icon': 'mdi-page-first',
                  'last-icon': 'mdi-page-last',
                  'prev-icon': 'mdi-chevron-left',
                  'next-icon': 'mdi-chevron-right',
                }"
              >
                <template v-slot:item.avatar="{ item }">
                  <v-avatar size="32" color="grey lighten-4">
                    <v-icon>mdi-account</v-icon>
                  </v-avatar>
                </template>

                <template v-slot:item.nome="{ item }">
                  <div class="ml-2">
                    <div>{{ item.nome }}</div>
                    <div class="caption grey--text">{{ item.email }}</div>
                  </div>
                </template>

                <template v-slot:item.gerenciar="{ item }">
                  <v-chip
                    small
                    :color="item.gerenciar ? 'primary' : 'blue'"
                    text-color="white"
                    class="px-2"
                    @click="alternarPermissaoGerenciar(item)"
                    style="cursor: pointer"
                  >
                    <v-icon left small class="ml-1">{{
                      item.gerenciar ? "mdi-key" : "mdi-eye"
                    }}</v-icon>
                    {{ item.gerenciar ? "Gerenciar" : "Visualizar" }}
                  </v-chip>
                </template>

                <template v-slot:item.acoes="{ item }">
                  <v-btn
                    small
                    text
                    color="error"
                    @click="removerCompartilhamento(item)"
                  >
                    <v-icon left small>mdi-close</v-icon>
                    Remover
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgCompartilhar = false">Cancelar</v-btn>
          <v-btn
            color="info"
            :loading="savingCompartilhamento"
            @click="salvarCompartilhamento"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-link-variant"
            title="Grupos Colaboradores"
            color="rgb(71 130 180)"
            style="
              margin-top: 60px !important;
              padding-top: 10px !important;
              min-height: 60vh;
            "
            class="px-5 py-0"
          >
            <!-- Botão para adicionar novo grupo -->
            <v-card-actions class="d-flex justify-end px-0 py-0">
              <v-btn
                color="primary"
                @click="abrirFormNovoGrupo"
                small
                v-if="!showForm"
                width="140px"
              >
                <v-icon left>mdi-plus</v-icon>Novo Grupo
              </v-btn>
            </v-card-actions>

            <!-- Formulário para criar/editar grupo -->
            <v-form v-if="showForm" ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <!-- Nome -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Nome do Grupo</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="grupoColaborador.grupo.nome"
                    label="Nome"
                    required
                    :rules="[(v) => !!v || 'Este campo é obrigatório']"
                  ></v-text-field>
                </v-col>

                <!-- Modelo -->
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <span>Modelo</span>
                  <v-select
                    dense
                    solo-inverted
                    v-model="grupoColaborador.grupo.modelo"
                    :items="['Mensageria', 'Arquivos']"
                    label="Modelo"
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                  ></v-select>
                </v-col>

                <!-- Status -->
                <!-- <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-switch
                    inset
                    color="blue"
                    v-model="grupoColaborador.grupo.status"
                    label="Status"
                    class="mt-0"
                  ></v-switch>
                </v-col> -->
              </v-row>

              <!-- Campo de busca -->
              <v-row class="px-0 py-0">
                <v-col cols="6"></v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Procurar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-data-table
                :headers="header_colaboradores"
                :items="listaColaboradores"
                :search="search"
                v-model="colaboradoresSelecionados"
                show-select
                item-key="id"
                :items-per-page="20"
                class="elevation-0"
              >
                <!-- Somente a coluna empresa com chip -->
                <template v-slot:item.empresa="{ item }">
                  <v-chip
                    :color="getStatusCor(item.empresa)"
                    text-color="white"
                  >
                    {{ item.empresa }}
                  </v-chip>
                </template>
              </v-data-table>

              <!-- Ações do formulário -->
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  outlined
                  small
                  v-if="showEditar || showForm"
                  color="red"
                  @click="cancelarOperacao()"
                >
                  <v-icon left>mdi-cancel</v-icon>Cancelar
                </v-btn>
                <v-btn
                  small
                  v-if="!showEditar"
                  :loading="loadingCreate"
                  color="primary"
                  @click="adiciona_colaborador"
                  class="mr-0"
                >
                  <v-icon left>mdi-check-bold</v-icon>Criar Grupo
                </v-btn>

                <v-btn
                  small
                  v-if="showEditar"
                  :loading="loadingUpdate"
                  color="warning"
                  @click="atualizar_colaborador"
                >
                  <v-icon left>mdi-update</v-icon>Atualizar Grupo
                </v-btn>
              </v-card-actions>
            </v-form>

            <!-- Listagem dos grupos -->
            <v-data-table
              style="margin-top: 1rem"
              :headers="header"
              :items="listaGruposColaborador"
              :items-per-page="20"
              items-per-page-text="Linhas por página"
              class="elevation-0"
              v-if="!showForm && !showEditar"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td
                    class="linha"
                    style="
                      font-size: 11px !important;
                      font-weight: bold;
                      font-family: Verdana, Geneva, Tahoma, sans-serif;
                    "
                  >
                    {{ row.item.grupo.nome }}
                  </td>
                  <td class="linha">{{ row.item.responsavel }}</td>
                  <td class="linha" style="width: 200px">
                    <v-chip
                      :color="row.item.grupo.status ? 'green' : 'red'"
                      text-color="white"
                    >
                      {{ row.item.grupo.status ? "ATIVO" : "DESATIVADO" }}
                    </v-chip>
                  </td>
                  <td class="linha" style="width: 200px">
                    {{ row.item.colaboradores.length }}
                  </td>
                  <td class="linha" style="width: 200px">
                    {{ row.item.grupo.dataCriacao }}
                  </td>
                  <td class="linha" style="width: 200px">
                    {{ row.item.grupo.modelo }}
                  </td>
                  <td class="linha" style="width: 300px">
                    <v-btn
                      @click="editarColaborador(row.item)"
                      text
                      small
                      color="warning"
                    >
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      @click="duplicarGrupoColaborador(row.item.grupo.id)"
                      text
                      small
                      color="primary"
                    >
                      <v-icon dark>mdi-content-duplicate</v-icon>
                    </v-btn>
                    <v-btn
                      @click="abrirCompartilhamento(row.item)"
                      text
                      small
                      color="info"
                    >
                      <v-icon dark>mdi-share-variant</v-icon>
                    </v-btn>
                    <v-btn
                      @click="
                        atualizarStatusGrupo(
                          row.item.grupo.id,
                          !row.item.grupo.status
                        )
                      "
                      text
                      x-small
                      :color="row.item.grupo.status ? 'red' : 'green'"
                    >
                      <v-icon dark>{{
                        row.item.grupo.status ? "mdi-close" : "mdi-check"
                      }}</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import VuetifyMoney from "./components/VuetifyMoney.vue";
import rh from "../../services/rh";

export default {
  name: "MensageriaCobranca",
  components: {
    apexcharts: ContentLoader,
    "vuetify-money": VuetifyMoney,
  },

  created() {},

  mounted() {
    this.consultar_grupo_colaboradores();
    this.consultar_colaboradores();
  },

  data() {
    return {
      search: "",
      valid: true,
      showForm: false,
      showEditar: false,
      isLoading: false,
      loadingCreate: false,
      loadingUpdate: false,
      loadingDuplicar: false,
      loadingCancelar: false,
      duplicarGrupoDialog: false,
      cancelarOperacaoDialog: false,
      mensagemDialog: false,
      dlgCompartilhar: false,
      grupoSelecionado: null,
      compartilharSelecionados: [],
      loadingCompartilhamento: false,
      savingCompartilhamento: false,
      searchCompartilhados: "",
      searchDisponiveis: "",
      colaboradoresCompartilhados: [],
      colaboradoresDisponiveis: [],
      grupoResponsavel: "",
      totalParticipantes: 0,
      headersCompartilhados: [
        { text: "Nome", value: "nome", width: "30%" },
        { text: "Email", value: "email", width: "30%" },
        { text: "Telefone", value: "telefone", width: "20%" },
        { text: "Departamento", value: "departamento", width: "15%" },
        { text: "Ações", value: "acoes", sortable: false, width: "5%" },
      ],
      headersDisponiveis: [
        { text: "Nome", value: "nome", width: "30%" },
        { text: "Email", value: "email", width: "30%" },
        { text: "Telefone", value: "telefone", width: "20%" },
        { text: "Departamento", value: "departamento", width: "15%" },
        { text: "Ações", value: "acoes", sortable: false, width: "5%" },
      ],
      mensagemTexto: "",
      mensagemTipo: "sucesso",
      grupoIdParaDuplicar: null,
      grupoIdParaAtualizar: null,
      atualizarGrupoStatusDialog: false,
      statusGrupoAtualizarStatus: null,
      colaboradoresSelecionados: [],
      listaColaboradores: [],
      listaGruposColaborador: [],
      grupoColaborador: {
        grupo: {
          id: 0,
          nome: "",
          status: true,
          modelo: "",
        },
        colaboradores: [],
      },
      header_colaboradores: [
        { text: "", value: "selecionar", sortable: false },
        { text: "Empresa", value: "empresa" },
        { text: "Nome Completo", value: "nome" },
        { text: "Telefone", value: "telefone" },
        { text: "E-mail", value: "email" },
        { text: "Departamento", value: "departamento" },
        { text: "Cargo", value: "cargo" },
      ],
      header: [
        { text: "Nome", value: "nome" },
        { text: "Responsável", value: "responsavel" },
        { text: "Status", value: "status" },
        { text: "Colaboradores", value: "colaboradores" },
        { text: "Data de Criação", value: "dataCriacao" },
        { text: "Modelo", value: "modelo" },
        { text: "Ações", value: "acao", sortable: false, align: "center" },
      ],
      isLoading: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "PARQUE DAS FLORES",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
      ],
      cargos: [
        "Gerente",
        "Assistente",
        "Analista",
        "Coordenador",
        "Diretor",
        "Supervisor",
      ],
    };
  },

  methods: {
    abrirCompartilhamento(grupo) {
      this.grupoSelecionado = grupo.grupo;
      this.grupoResponsavel = grupo.responsavel || "Não informado";
      this.totalParticipantes = grupo.colaboradores?.length || 0;
      this.dlgCompartilhar = true;
      this.loadingCompartilhamento = true;
      this.searchCompartilhados = "";
      this.searchDisponiveis = "";

      // Verificar se o grupo já tem compartilhados
      const compartilhados = grupo.compartilhados || [];
      // Extrair os IDs dos compartilhados (agora usando idAlelo)
      const compartilhadosIds = compartilhados.map((c) => c.idAlelo);

      // Carregar todos os colaboradores e separar em compartilhados e disponíveis
      this.atualizarListasColaboradores(compartilhadosIds, compartilhados);
    },

    // Atualiza as listas de colaboradores compartilhados e disponíveis
    atualizarListasColaboradores(compartilhadosIds, compartilhados = []) {
      // Garantir que temos a lista completa de colaboradores
      if (this.listaColaboradores.length === 0) {
        this.consultar_colaboradores();
      }

      // Criar um mapa de colaboradores compartilhados com seus atributos
      const compartilhadosMap = {};
      compartilhados.forEach((c) => {
        // Novo formato com idAlelo e gerenciar
        if (typeof c === "object" && c.idAlelo) {
          compartilhadosMap[c.idAlelo] = { gerenciar: c.gerenciar || false };
        }
        // Formato antigo ou apenas ID
        else if (typeof c === "object" && c.id) {
          compartilhadosMap[c.id] = { gerenciar: c.gerenciar || false };
        } else if (typeof c === "number" || typeof c === "string") {
          compartilhadosMap[c] = { gerenciar: false };
        }
      });

      // Separar colaboradores em compartilhados e disponíveis
      this.colaboradoresCompartilhados = this.listaColaboradores
        .filter((colab) => compartilhadosIds.includes(colab.id))
        .map((colab) => {
          // Adicionar o atributo gerenciar ao colaborador
          return {
            ...colab,
            gerenciar: compartilhadosMap[colab.id]?.gerenciar || false,
          };
        });

      this.colaboradoresDisponiveis = this.listaColaboradores.filter(
        (colab) => !compartilhadosIds.includes(colab.id)
      );

      // Atualizar a lista de IDs selecionados
      this.compartilharSelecionados = [...compartilhadosIds];

      this.loadingCompartilhamento = false;
    },

    // Adicionar um colaborador à lista de compartilhados
    adicionarCompartilhamento(colaborador) {
      // Mover da lista de disponíveis para compartilhados
      const index = this.colaboradoresDisponiveis.findIndex(
        (c) => c.id === colaborador.id
      );
      if (index !== -1) {
        // Remover da lista de disponíveis
        this.colaboradoresDisponiveis.splice(index, 1);
        // Adicionar à lista de compartilhados com atributo gerenciar
        this.colaboradoresCompartilhados.push({
          ...colaborador,
          gerenciar: false, // Por padrão, novos colaboradores não têm permissão de gerenciar
        });
        // Atualizar IDs selecionados
        this.compartilharSelecionados.push(colaborador.id);
      }
    },

    // Remover um colaborador da lista de compartilhados
    removerCompartilhamento(colaborador) {
      // Mover da lista de compartilhados para disponíveis
      const index = this.colaboradoresCompartilhados.findIndex(
        (c) => c.id === colaborador.id
      );
      if (index !== -1) {
        // Remover da lista de compartilhados
        this.colaboradoresCompartilhados.splice(index, 1);
        // Adicionar à lista de disponíveis
        this.colaboradoresDisponiveis.push(colaborador);
        // Atualizar IDs selecionados
        const idIndex = this.compartilharSelecionados.indexOf(colaborador.id);
        if (idIndex !== -1) {
          this.compartilharSelecionados.splice(idIndex, 1);
        }
      }
    },

    // Alternar permissão de gerenciamento de um colaborador
    alternarPermissaoGerenciar(colaborador) {
      // Encontrar o colaborador na lista
      const index = this.colaboradoresCompartilhados.findIndex(
        (c) => c.id === colaborador.id
      );
      if (index !== -1) {
        // Alternar o valor do atributo gerenciar
        this.colaboradoresCompartilhados[index].gerenciar =
          !this.colaboradoresCompartilhados[index].gerenciar;
      }
    },

    salvarCompartilhamento() {
      if (!this.grupoSelecionado?.id) return;

      this.savingCompartilhamento = true;

      // Preparar dados para envio incluindo permissões de gerenciamento
      // Formato esperado pelo backend: [{idAlelo: number, gerenciar: boolean}]
      const compartilhadosData = this.colaboradoresCompartilhados.map((c) => ({
        idAlelo: c.id,
        gerenciar: c.gerenciar || false,
      }));

      rh.atualizarCompartilhamentoGrupo(
        this.grupoSelecionado.id,
        compartilhadosData
      )
        .then(() => {
          // Atualizar o objeto grupo na lista
          const grupoIndex = this.listaGruposColaborador.findIndex(
            (item) => item.grupo.id === this.grupoSelecionado.id
          );

          if (grupoIndex !== -1) {
            // Atualizar o array de compartilhados no objeto grupo
            this.listaGruposColaborador[grupoIndex].grupo.compartilhados = [
              ...this.compartilharSelecionados,
            ];
          }

          this.mostrarMensagemSucesso(
            "Compartilhamento atualizado com sucesso"
          );
          this.dlgCompartilhar = false;
        })
        .catch((e) => {
          console.error("Erro ao salvar compartilhamento:", e);

          // Verificar se é erro de permissão (403)
          if (e.response && e.response.status === 403) {
            this.dlgCompartilhar = false;
            this.mostrarMensagemErro(
              "Você não tem permissão para compartilhar este grupo. Apenas o responsável ou usuários com permissão de gerenciamento podem realizar esta ação"
            );
          } else {
            this.mostrarMensagemErro("Erro ao atualizar compartilhamento");
          }
        })
        .finally(() => {
          this.savingCompartilhamento = false;
          this.consultar_grupo_colaboradores();
          this.consultar_colaboradores();
        });
    },

    abrirFormNovoGrupo() {
      this.showForm = true;
      this.showEditar = false;

      this.grupoColaborador = {
        grupo: {
          id: 0,
          nome: "",
          status: true,
        },
        colaboradores: [],
      };

      this.colaboradoresSelecionados = [];
    },

    getStatusCor(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";
        case "A FLOR DO CAFÉ":
          return "purple lighten-1";
        default:
          "success";
      }
    },
    getStatusDisparoCor(status) {
      switch (status) {
        case true:
          return "green darken-1";
        case false:
          return "red";
      }
    },
    getStatus(status) {
      switch (status) {
        case true:
          return "ATIVO";
        case false:
          return "DESATIVADO";
      }
    },

    duplicarGrupoColaborador(id) {
      this.grupoIdParaDuplicar = id;
      this.duplicarGrupoDialog = true;
    },

    fecharDialogDuplicar() {
      this.duplicarGrupoDialog = false;
      this.grupoIdParaDuplicar = null;
    },

    confirmarDuplicarGrupo() {
      this.loadingDuplicar = true;

      rh.duplicarGrupo(this.grupoIdParaDuplicar)
        .then((response) => {
          if (response.status === 200) {
            this.mostrarMensagemSucesso("Grupo duplicado com sucesso!");
            this.consultar_grupo_colaboradores();
          }
        })
        .catch((e) => {
          console.log(e);
          this.mostrarMensagemErro("Erro ao duplicar grupo.");
        })
        .finally(() => {
          this.loadingDuplicar = false;
          this.duplicarGrupoDialog = false;
          this.grupoIdParaDuplicar = null;
        });
    },

    mostrarMensagemSucesso(mensagem) {
      this.mensagemTexto = mensagem;
      this.mensagemTipo = "sucesso";
      this.mensagemDialog = true;
    },

    mostrarMensagemErro(mensagem) {
      this.mensagemTexto = mensagem;
      this.mensagemTipo = "erro";
      this.mensagemDialog = true;
    },

    cancelarOperacao() {
      this.clear_atualizacao();
      this.consultar_grupo_colaboradores();
    },

    atualizarStatusGrupo(id, status) {
      this.grupoIdParaAtualizar = id;
      this.statusGrupoAtualizarStatus = status;
      this.atualizarGrupoStatusDialog = true;
    },

    fecharDialogAtualizarStatusGrupo() {
      this.atualizarGrupoStatusDialog = false;
      this.grupoIdParaAtualizar = null;
      this.statusGrupoAtualizarStatus = null;
    },

    atualizarStatusGrupoColaborador() {
      this.loadingCancelar = true;
      rh.atualizarStatusGrupo(
        this.grupoIdParaAtualizar,
        this.statusGrupoAtualizarStatus
      )
        .then((response) => {
          if (response.status === 200) {
            this.mostrarMensagemSucesso("Status atualizado com sucesso!");
            this.consultar_grupo_colaboradores();
          }
        })
        .catch((e) => {
          console.log(e);

          // Verificar se é erro de permissão (403)
          if (e.response && e.response.status === 403) {
            this.mostrarMensagemErro(
              "Você não tem permissão para alterar o status este grupo. Apenas o responsável ou usuários com permissão de gerenciamento podem realizar esta ação"
            );
          } else {
            this.mostrarMensagemErro("Erro ao atualizar status.");
          }
        })
        .finally(() => {
          this.loadingCancelar = false;
          this.atualizarGrupoStatusDialog = false;
          this.grupoIdParaAtualizar = null;
          this.statusGrupoAtualizarStatus = null;
        });
    },
    editarColaborador(grupo) {
      this.grupoColaborador = { ...grupo };

      // Preenche com os objetos completos da lista, não apenas os IDs
      this.colaboradoresSelecionados = this.listaColaboradores.filter((colab) =>
        grupo.colaboradores.some((c) => c.id === colab.id)
      );

      this.showForm = true;
      this.showEditar = true;
    },
    clear_atualizacao() {
      this.showForm = false;
      this.showEditar = false;
      this.valid = false;
      this.search = "";
      this.grupoColaborador = {
        grupo: {
          id: 0,
          nome: "",
          status: true,
        },
        colaboradores: [],
      };

      this.colaboradoresSelecionados = [];
      this.listaGruposColaborador = [];
    },
    convertDate(dateString, format = "iso") {
      if (!dateString) return "";

      if (format === "iso") {
        // Verifica se a string está no formato ISO completo (contém 'T')
        if (dateString.includes("T")) {
          dateString = dateString.split("T")[0]; // Remove a parte do horário
        }

        // Converte de ISO (YYYY-MM-DD) para BR (DD/MM/YYYY)
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
      } else if (format === "br") {
        // Converte de BR (DD/MM/YYYY) para ISO (YYYY-MM-DD)
        const [day, month, year] = dateString.split("/");
        return `${year}-${month}-${day}`;
      }

      return dateString; // Retorna a string original se o formato não for reconhecido
    },
    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },

    adiciona_colaborador() {
      this.loadingCreate = true;

      if (this.$refs.form.validate()) {
        // Filtra os colaboradores selecionados da lista completa
        const colaboradoresSelecionadosObjs = this.listaColaboradores.filter(
          (c) => this.colaboradoresSelecionados.some((s) => s.id === c.id)
        );

        // Verifica se há colaboradores selecionados
        if (colaboradoresSelecionadosObjs.length === 0) {
          this.mostrarMensagemErro(
            "Selecione pelo menos um colaborador para criar o grupo."
          );
          this.loadingCreate = false;
          return;
        }

        // Prepara o objeto grupo no formato esperado pela API
        const grupo = {
          ...this.grupoColaborador.grupo,
          id:
            this.grupoColaborador.grupo.id === 0
              ? null
              : this.grupoColaborador.grupo.id,
          idUsuarioInsert: this.user?.id || null,
          dataCriacao: "",
        };

        // Prepara o DTO no formato esperado pelo backend
        const grupoComColaboradoresDTO = {
          grupo: grupo,
          colaboradores: colaboradoresSelecionadosObjs,
        };

        // Chama a API para salvar o grupo com colaboradores
        rh.salvar_grupo_com_colaboradores(grupoComColaboradoresDTO)
          .then((response) => {
            this.clear_atualizacao();
            this.consultar_grupo_colaboradores();
            this.valid = false;
            this.mostrarMensagemSucesso("Grupo criado com sucesso!");
          })
          .catch((e) => {
            console.error("Erro ao salvar grupo:", e);
            this.mostrarMensagemErro("Erro ao criar grupo.");
          })
          .finally(() => {
            this.loadingCreate = false;
          });
      } else {
        this.loadingCreate = false;
      }
    },
    consultar_colaboradores() {
      rh.lista_colaboradores_ativos()
        .then((response) => {
          this.listaColaboradores = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    consultar_grupo_colaboradores() {
      rh.lista_grupos_colaboradorores().then((response) => {
        this.listaGruposColaborador = response.data;
      });
    },
    atualizar_colaborador() {
      this.loadingUpdate = true;

      if (this.$refs.form.validate()) {
        const colaboradoresSelecionadosObjs = this.listaColaboradores.filter(
          (c) => this.colaboradoresSelecionados.some((s) => s.id === c.id)
        );

        this.grupoColaborador.colaboradores = colaboradoresSelecionadosObjs;
        rh.atualizar_grupo_colaborador(this.grupoColaborador)
          .then((response) => {
            this.mostrarMensagemSucesso("Grupo atualizado com sucesso!");
          })
          .catch((e) => {
            console.log(e);

            // Verificar se é erro de permissão (403)
            if (e.response && e.response.status === 403) {
              this.mostrarMensagemErro(
                "Você não tem permissão para editar este grupo. Apenas o responsável ou usuários com permissão de gerenciamento podem realizar esta ação"
              );
            } else {
              this.mostrarMensagemErro("Erro ao atualizar grupo.");
            }
          })
          .finally(() => {
            this.valid = false;
            this.loadingUpdate = false;
            this.clear_atualizacao();
            this.consultar_grupo_colaboradores();
          });
      } else {
        this.loadingUpdate = false;
      }
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}

.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(71 130 180);
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.card-container {
  display: flex;
  justify-content: space-around;
}

.icon-avatar {
  position: static !important;
  opacity: 1 !important;
}
</style>
